module.exports = __webpack_public_path__ + "img/godo_pc_02.da5cb262.png";